
import { ILocationOption } from '@types-custom/models/business/location.model';
import { IGridTableHeaderModel } from '@types-custom/models/ui/grid-table-model';
import { Breadcrumb } from '@types-custom/models/ui/breadcrumb-model';
import { GridTypeEnum } from '@shared/utils/mappers/grid-mapper';

export enum IAuditComponent {
    PRINCIPAL = 'principal',
    SEARCH_AUDIT_USER = 'search-audit-user',
    SEARCH_AUDIT_RECORD = 'search-audit-record',
    GRID_AUDIT_USER = 'grid-audit-user',
    GRID_AUDIT_RECORD = 'grid-audit-record',
    PANEL_AUDIT_INFO = 'panel-audit-info',
}

export enum IActionAudit {
  CREATE = 'Crear',
  UPDATE = 'Editar',
}

export const actionsAuditList = [
  {
    label: IActionAudit.CREATE,
    value: 'CREATE',
  } as ILocationOption,

  {
    label: IActionAudit.UPDATE,
    value: 'UPDATE',
  } as ILocationOption,
];

export interface IAuditModel {
  id?: string;
  code?: string;
  data?: any;
  dataAux?: any;
  renderPrincipal?: boolean;
  renderGridUser?: boolean;
  renderGridRecord?: boolean;
  renderAuditPanel?: boolean;
  routes?: Breadcrumb[];
}

export interface IAuditPanelInfo {
  model: IAuditModel;
  headersMain: IGridTableHeaderModel[];
  headersBody: IGridTableHeaderModel[];
  dataMain: any;
  dataBody: any;
}

export interface IAuditSearchUserModel {
  id: string;
  userName: string;
  userRealName: string;
  auditType: string;
  actionDate: string;
}


export interface IAuditSearchRecordModel {
  id: string;
  name: string;
  auditType: string;
  actionDate: string;
}

export interface IAuditGridModel {
  id: string;
  revId: number;
  name: string;
  auditType: string;
  creationDate: string;
}

export const fileNameAuditDownloaded: { [key: string]: string } = {
  [GridTypeEnum.ManageGridUserAudit]:   'Lista de auditoria por usuario',
  [GridTypeEnum.ManageGridRecordAudit]:   'Lista de auditoria por registro',
};
